export default function IntroductionPlan() {
  const plans = [
    {
      icon: 'ri-store-2-line',
      title: '販売代理店からの購入',
      badge: '定価販売',
      badgeColor: 'bg-stone-100 text-stone-700',
      description: '販売代理店を通じてご購入いただけます。定価にてご提供いたします。',
      price: '購入価格 ¥10,000（税抜）',
      highlight: false,
    },
    {
      icon: 'ri-user-heart-line',
      title: '一般販売',
      badge: '来店特典',
      badgeColor: 'bg-amber-100 text-amber-700',
      description: '当店への10回来店で購入クーポンを取得。',
      price: '購入価格 ¥7,500（税抜）',
      highlight: true,
    },
    {
      icon: 'ri-building-4-line',
      title: 'シーシャ提供店舗',
      badge: '店舗向け',
      badgeColor: 'bg-emerald-100 text-emerald-700',
      description: 'シール2枚貼り付けで５個まで購入可能。',
      price: '購入価格 ¥7,500（税抜）',
      highlight: false,
    },
  ];

  return (
    <section id="introduction-plan" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-4">導入プラン</h2>
          <p className="text-gray-500 text-lg">あなたのスタイルに合わせてお選びください</p>
        </div>

        {/* Plan Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-3xl p-8 flex flex-col gap-4 border transition-all duration-300 hover:-translate-y-1 ${
                plan.highlight
                  ? 'bg-amber-50 border-amber-200'
                  : 'bg-gray-50 border-gray-100'
              }`}
            >
              {/* Icon & Badge */}
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white border border-gray-100">
                  <i className={`${plan.icon} text-2xl text-gray-700`} />
                </div>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${plan.badgeColor}`}>
                  {plan.badge}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900">{plan.title}</h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed">{plan.description}</p>

              {/* Price */}
              {plan.price && (
                <div className="mt-auto pt-4 border-t border-gray-200">
                  <p className="text-lg font-bold text-amber-700">{plan.price}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom notice */}
        <div className="rounded-2xl bg-red-50 border border-red-200 px-8 py-5">
          <p className="text-sm text-red-600 leading-relaxed font-semibold mb-1">ご注意：</p>
          <p className="text-sm text-red-600 leading-relaxed">
            5個以上お求めのシーシャ提供店舗様は、Instagram・X・電話にて直接お声がけください。
          </p>
          <p className="text-sm text-red-600 leading-relaxed mt-1">
            シーシャを提供するために必要な営業許可証のご相談も協力可能です。
          </p>
        </div>
      </div>
    </section>
  );
}
